module.exports = __webpack_public_path__ + "static/media/no-spotlight.a687f016.svg";